export default __webpack_public_path__ + "static/media/summary.ece67070.png";